//prettier-ignore
export enum SensorType {
    UnknownSensorType = 0,
    KosaSensorType = 1,
}

export function sensorTypeStr(type: SensorType): string {
    // prettier-ignore
    switch (type){
        case SensorType.KosaSensorType : return 'Коса';
        default : return ''
    }
}

//=================================================================================================
//prettier-ignore
export enum SensorState {
    SensorStateOk            = 0,
    SensorStateAnyDataBroken = 1,
    SensorStatePowerError    = 0xfd,
    SensorStateNotConnected  = 0xfe,
    SensorStateUndefSensor   = 0xff,
}

export function sensorStateStr(state: SensorState): string {
    // prettier-ignore
    switch (state){
        case SensorState.SensorStateOk            : return 'OK';
        case SensorState.SensorStatePowerError    : return 'Ошибка питания';
        case SensorState.SensorStateAnyDataBroken : return 'Ошибка данных';
        case SensorState.SensorStateNotConnected  : return 'Не подключен';
        case SensorState.SensorStateUndefSensor   : return 'Не определен';
        default : return '';
    }
}
